<template>
  <div class="box bar-chart">
    <database-not-found
      v-show="noData"
      class="bar-area"
    />
    <div
      ref="title"
      class="bar-area"
    >
    </div>
  </div>
</template>

<script>
import DatabaseNotFound from '../components/etc/DatabaseNotFound.vue'
import { barOption } from '../setting/summaryBarChart'
import * as echarts from 'echarts'
export default {
  name: 'BarChart',
  props: ['chartData', 'title'],
  components: { DatabaseNotFound },
  data () {
    return {
      noData: false
      //   option: { ...optionPie }
    }
  },
  watch: {
    chartData: {
      handler (val) {
        // console.log('chartData', val)
        if (val.source.length) {
          try {
            this.noData = false
            this.chart.setOption(this.formattdata)
            // console.log('this.nodata', this.noData)
            // console.log('this.formattdata', this.formattdata)
          } catch (error) {
            // console.log('error', error)
          }
        } else {
          this.noData = true
        }
      }
    }
  },
  mounted () {
    // console.log('this.noData', this.noData)
    this.initChart()
  },
  computed: {
    formattdata () {
      const customXaxis = [...barOption.xAxis]
      customXaxis[0] = {
        type: 'value',
        name: 'Orders',
        min: 0,
        max:
          Math.ceil(Math.max(...this.chartData.source.map((i) => i[1])) / 10) *
          10,
        position: 'top',
        axisLabel: {
          formatter: '{value} Order(s)'
        }
      }
      barOption.legend = {
        selected: {
          'On-time(%)': false
        }
      }
      barOption.xAxis = customXaxis
      barOption.dataset = [
        {
          dimensions: this.chartData.dimensions,
          source: this.chartData.source
        },
        {
          transform: {
            type: 'sort',
            config: { dimension: 'on-time', order: 'asc' }
          }
        }
      ]
      barOption.series = [
        {
          name: 'On-time',
          type: 'bar',
          encode: { y: 'branch', x: 'on-time' },
          datasetIndex: 1,
          xAxisIndex: 0
        },
        {
          name: 'Late',
          type: 'bar',
          encode: { y: 'branch', x: 'late' },
          xAxisIndex: 0
        },
        {
          name: 'On-time(%)',
          type: 'bar',
          encode: { y: 'branch', x: 'percentOn' },
          xAxisIndex: 1
        }
      ]
      // console.log('barOption.dataset', barOption.dataset)
      return barOption
    }
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$refs.title)
      this.chart.setOption(this.formattdata)
    }
  }
}
</script>

<style>
.bar-chart {
  width: 100%;
}
.bar-area {
  width: 100%;
  height: 100%;
}
</style>
